module.exports = __webpack_public_path__ + "img/zoe_estates_bg_102.e7986795.jpg";